module.exports = "<xo-generic-error ng-if=shouldRender token=\"token\" merchant={{merchant}} cancel-url={{cancelUrl}} is-unbranded=\"isUnbranded\"></xo-generic-error>\n"


//////////////////
// WEBPACK FOOTER
// ./pages/xo-generic-error/template.html
// module id = ./pages/xo-generic-error/template.html
// module chunks = 0